module.exports = require("@embedpdf/plugin-scroll/react");